var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compensation-steps"},[_c('ul',{staticClass:"compensation-steps__list"},_vm._l((_vm.steps),function(step,idx){return _c('li',{key:idx,staticClass:"compensation-steps__item"},[_c('CompensationStep',{attrs:{"text-html":step.textHtml,"order-number":idx + 1,"hide-step-arrow":idx === _vm.steps.length - 1}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }